(function userAssociateRolesControllerDefinition() {
    'use strict';

    angular.module('User')
        .controller('UserAssociateRolesController', [
            '$scope', 'config', '$state', '$translate', '$stateParams', 'errorsExtend', 'adminUserService', 'adminRoleService', '$uibModal', '$q', 'organizationalUnitService', '$filter', 'authExtend',
            function userAssociateRolesController($scope, config, $state, $translate, $stateParams, errors, adminUserService, adminRoleService, $modal, $q, organizationalUnitService, $filter, auth) {
                $scope.models = {
                    selected: null,
                    selectedOu: null,
                    associated: {
                        "title": null,
                        "list": []
                    },
                    availables: {
                        "title": null,
                        "list": []
                    }
                };

                $translate(['UserAssociateRolesTitle', 'RoleAssociatedList', 'RoleAvailableList']).then(function (translated) {
                    $scope.title = translated.UserAssociateRolesTitle;
                    $scope.models.associated.title = translated.RoleAssociatedList;
                    $scope.models.availables.title = translated.RoleAvailableList;
                });

                $scope.loadUser = function () {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    adminUserService.getById($stateParams.id).then(function (result) {
                        var roles = [];
                        result.roles.forEach(function (role) {
                            var roleOu = $filter('filter')(roles, { id: role.roleId }, true);
                            if (roleOu && roleOu.length > 0) {
                                roleOu[0].organizationalUnits.push({ id: role.organizationalUnitId });
                            } else {
                                var rolOu = {
                                    id: role.roleId,
                                    name: role.roleName,
                                    organizationalUnitId: role.organizationalUnitId,
                                    organizationalUnitName: role.organizationalUnitName,
                                    organizationalUnits: [],
                                    rolOUName: role.roleOrganizationalUnitName
                                };
                                rolOu.organizationalUnits.push({ id: role.organizationalUnitId });
                                roles.push(rolOu);
                            }
                        });
                        $scope.userOu = result;
                        roles = $filter('orderBy')(roles, ['name', 'rolOUName']);
                        roles.forEach(function (item) {
                            item.visible = true;
                        });
                        $scope.models.associated.list = roles;

                    }, function (error) {
                        defered.reject(error);
                    }).then(function () {

                        var ouId = $scope.userOu.organizationalUnit == null ? null : $scope.userOu.organizationalUnit.id;
                        adminRoleService.getNotInUser($stateParams.id, ouId).then(function (result) {
                            result = result.value;
                            result = $filter('orderBy')(result, ['name', 'organizationalUnitName']);

                            result.forEach(function (item) {
                                item.visible = true;
                            });

                            $scope.models.availables.list = result;
                            defered.resolve();
                        });
                    }, function (errors) {
                        defered.reject(errors);
                    });

                    return promise;
                };

                $scope.loadOus = function () {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    organizationalUnitService.getUserTree($stateParams.id).then(function (ous) {
                        $scope.ous = ous;

                        $scope.ous.unshift({
                            id: 0,
                            name: 'Genéricos'
                        });

                        $scope.ous.unshift({
                            id: -1,
                            name: 'Todas'
                        });

                        $scope.models.selectedOu = $scope.ous[0];

                        defered.resolve();
                    }, function getError(error) {
                        defered.reject(error);
                    });

                    return promise;
                };

                $scope.ouChanged = function () {
                    $scope.models.availables.list.forEach(function (item) {
                        if ($scope.models.selectedOu.id === -1) {
                            item.visible = true;
                        } else if ($scope.models.selectedOu.id === 0) {
                            item.visible = angular.isUndefined(item.organizationalUnitId) || item.organizationalUnitId == null;
                        } else {
                            item.visible = $scope.models.selectedOu.id === item.organizationalUnitId;
                        }
                    });
                };

                $scope.cancel = function () {
                    $state.go('user-find');
                };

                $scope.save = function () {
                    $scope.userOu.applicationId = config.appId();

                    var roles = [];

                    $scope.models.associated.list.forEach(function (role) {
                        if (!role.organizationalUnits && role.organizationalUnits.length == 0) {
                            roles.push({ roleId: role.id, organizationalUnitId: null });
                        } else {
                            role.organizationalUnits.forEach(function (ou) {
                                roles.push({ roleId: role.id, organizationalUnitId: ou.id });
                            });
                        }
                    });

                    $scope.userOu.roles = roles;

                    return adminUserService.modify($scope.userOu).then(function () {
                        $state.go('user-find');
                    },
                        function (error) {
                            errors.showError(error);
                        });
                };

                $scope.moveRoleFromAssociated = function (role, index) {
                    $scope.models.associated.list.splice(index, 1);
                    $scope.models.availables.list.push(role);
                    role.organizationalUnitName = role.rolOUName;
                    role.organizationalUnitId = role.rolOUName != null ? role.organizationalUnitId : null;
                    $scope.ouChanged();
                };

                $scope.moveRoleFromAvailables = function (role, index) {
                    $scope.models.availables.list.splice(index, 1);
                    $scope.models.associated.list.push($scope.modifyRoleUser(role, index, true));
                    role.rolOUName = role.organizationalUnitName;
                };

                var modalController = function ($scope, $modalInstance, $translate, info) {

                    setValue($scope, 'title', info.name);
                    $scope.optionsRoleOu = info.optionsRoleOu;
                    $scope.aux = { selectedRoleOu: info.selectedRoleOu }

                    $scope.ok = function () {
                        if ($scope.ouModalForm.$valid) {
                            $modalInstance.close($scope.aux.selectedRoleOu);
                        } else {
                            errors.showError('VerifyFormData');
                        }
                    };

                    $scope.cancel = function () {
                        $modalInstance.dismiss('cancel');
                    };
                };

                modalController.$inject = ['$scope', '$modalInstance', '$translate', 'info'];

                $scope.dndRoleToUser = function (event, index, item) {
                    return $scope.modifyRoleUser(item, index, true);
                };

                $scope.modifyRoleUser = function (item, index, isCancel) {
                    $scope.item = item;
                    $scope.item.previousIndex = index;
                    $scope.index = index;
                    $scope.isCancel = isCancel;

                    openModal($scope.ous, $scope.item).then(function (resultModal) {
                        var roleOu = $filter('filter')($scope.models.associated.list, { id: $scope.item.id }, true);
                        if (roleOu.length > 0) {
                            roleOu[0].organizationalUnits = [];
                            resultModal.forEach(function (ou) {
                                roleOu[0].organizationalUnits.push(ou);
                            });
                        }
                    }, function (error) {
                        if ($scope.isCancel) {
                            $scope.cancelRoleUser($scope.item, $scope.index);
                        }
                    });

                    return item;
                };

                $scope.cancelRoleUser = function (item, index) {
                    var role = $filter('filter')($scope.models.associated.list, { id: item.id }, true);

                    if (role.length > 0) {
                        var roleCanceled = $scope.models.associated.list.splice($scope.models.associated.list.indexOf(role[0]), 1);

                        $scope.models.availables.list.splice(role[0].previousIndex, 0, roleCanceled[0]);
                    }
                };

                function openModal(ous, item) {

                    $scope.optionsRoleOu = ous;
                    $scope.selectedRoleOu = [];

                    if (item.organizationalUnits == null) {
                        item.organizationalUnits = [];
                    }

                    if (!angular.isUndefined(item.organizationalUnitId) && item.organizationalUnits.length == 0) {
                        var oudefalutId = null;

                        if ($scope.userOu.organizationalUnitId) {
                            oudefalutId = $scope.userOu.organizationalUnitId;
                        } else {
                            oudefalutId = item.organizationalUnitId
                        }

                        var ouDefault = $filter('filter')($scope.optionsRoleOu, { id: oudefalutId }, true);

                        if (ouDefault != null && ouDefault[0]) {
                            $scope.selectedRoleOu.push(ouDefault[0]);
                        }
                    }

                    item.organizationalUnits.forEach(function (ou) {

                        var ouDefault = $filter('filter')($scope.selectedRoleOu, { id: ou ? ou.id : undefined }, true);

                        if (ouDefault.length == 0) {
                            var ouFilter = $filter('filter')($scope.optionsRoleOu, { id: ou ? ou.id : undefined }, true);

                            if (ouFilter && ouFilter.length > 0) {
                                $scope.selectedRoleOu.push(ouFilter[0]);
                            }
                        }
                    });

                    var modalInstance = $modal.open({
                        backdrop: 'static',
                        keyboard: false,
                        templateUrl: '/app/views/user/partial-ou-association.html',
                        controller: modalController,
                        size: 'md',
                        resolve: {
                            info: function () {
                                return {
                                    name: $translate.instant('RoleOrganizationalUnit'),
                                    optionsRoleOu: $scope.optionsRoleOu,
                                    selectedRoleOu: $scope.selectedRoleOu
                                };
                            }
                        }
                    });

                    return modalInstance.result;
                };

                function setValue(scope, property, value) {
                    if (value) {
                        $q.when(value).then(function (val) {
                            scope[property] = val;
                        });
                    }
                }

                $scope.load = function () {
                    var promesaMultipleArray = $q.all([$scope.loadOus(), $scope.loadUser()]);

                    promesaMultipleArray.then(function () {
                        if ($scope.userOu.organizationalUnitId == null) {
                            $scope.ous.push({ id: null, name: "Root" });
                        }

                    }, function (error) {
                        errors.showError(error);
                        $scope.cancel();
                    });
                };

                $scope.load();
            }
        ]);
})();